import { Card, CardContent, LinearProgress } from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import AppConfig from "../../../../../../app/config/AppConfig";
import { myJsonEncrypt, myJsonDecrypt } from "../../../../../../app/config/SecurityConfig";
class LoginASPT extends Component {
  state = {
    lembaga: "1",
    status: false,
    loading1: false,
    loading2: false,
    data_loaded1: false,
    data_loaded2: false,
    data_chart1: [],
    data_chart2: [],
    // total_data1: [],
    total_data2: [],

    dataSP: [],
    id_sp: "",
    nama_sp: "",
    loadingAuth: false,
  };

  setRole(e, i) {
    console.log(e);
    console.log(i);
  }

  onChangeSP = (e, id_pembina) => {
    this.setState({
      id_sp: "",
      nama_sp: e.target.value,
    });
    if (e.target.value.length > 2) {
      this.setState({
        displaySP: false,
        loadingSP: true,
      });

      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
      let session = "";
      if (userdata) {
        session =
          "?id_pengguna=" +
          userdata.id_pengguna +
          "&id_unit=" +
          sessiondata.i_idunit +
          "&id_role=" +
          sessiondata.i_idrole;
      }

      var formData = new FormData();
      formData.append("data[id_pembina]", id_pembina);
      formData.append("data[keyword]", e.target.value);
      formData.append("data[id_bp]", sessiondata.i_idbp);

      axios.defaults.headers.post["Content-Type"] =
        "application/x-www-form-urlencoded";
      axios
        .post(AppConfig.GetPTPenugasanFaswil + session, formData)
        .then((res) => {
          if (res.status === 200) {
          }
          this.setState({
            dataSP: res.data.result.data,
            displaySP: true,
            loadingSP: false,
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    } else {
      this.setState({
        displaySP: false,
      });
    }
  };

  setWithExpiry = (key, value, ttl) => {
    let now = new Date();
    let item = {
      value: value,
      expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
  }

  onClickSelectSP = (id_sp, nama_sp) => {
    this.setState({
      id_sp: id_sp,
      nama_sp: nama_sp,
      displaySP: false,
      loadingAuth: true,
    });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";

    const payload = {
      id_role_pengguna: "",
      id_pengguna: userdata.id_pengguna,
      username: userdata.username,
      token: userdata.token,
      is_edit: userdata.is_edit,
      login_as_pt: "true",
      id_sp: id_sp,
    };
    const formData = new FormData()
    formData.append("data", myJsonEncrypt(JSON.stringify(payload)))

    axios.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
    axios
      .post(AppConfig.SetRole + session, formData)
      .then((res) => {
        let dec = myJsonDecrypt(res.data.result);
        let jresult = JSON.parse(dec);
        if (jresult.status === "success") {
          localStorage.setItem("userdata", JSON.stringify(userdata));
          localStorage.setItem(
            "sessiondata",
            JSON.stringify(jresult.session_data)
          );
          this.setState({
            loadingAuth: false,
          });
          this.setWithExpiry("statlogin", "true", 7200 * 1000);
          window.location.href = window.location.origin;
        } else {
          this.setState({
            loadingAuth: false,
            status: "Login gagal.",
          });
        }
      })
      .catch((err) => {
        this.setState({
          loadingAuth: false,
          status: "Server error.",
        });
      });
  };
  async componentDidMount() {
  }

  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    console.log(sessiondata);

    let loadSP = <></>;
    if (this.state.loadingSP === true) {
      loadSP = (
        <i
          className="ml-3 spinner spinner-black"
          style={{
            position: "absolute",
            zIndex: 2,
            right: "45px",
            bottom: "20px",
          }}
        ></i>
      );
    }

    let listSPPenugasan = <></>;
    if (this.state.displaySP === true) {
      if (this.state.dataSP) {
        let dataSp = [];
        this.state.dataSP.map((v, i) => {
          dataSp.push(
            <div
              onClick={(e) => this.onClickSelectSP(v.id_sp, v.nm_lemb)}
              style={{
                background: "#fff",
                padding: "10px",
                color: "#2c2c2c",
                borderBottom: "1px solid #ccc",
                cursor: "pointer",
              }}
            >
              {v.nm_lemb}
            </div>
          );
        });
        listSPPenugasan = (
          <div
            style={{
              position: "absolute",
              zIndex: "2",
              boxShadow: "0 4px 8px 0 rgb(0 0 0 / 15%)",
              width: "100%",
            }}
          >
            {dataSp}
          </div>
        );
      } else {
        listSPPenugasan = (
          <div
            style={{
              position: "absolute",
              zIndex: "2",
              boxShadow: "0 4px 8px 0 rgb(0 0 0 / 15%)",
              background: "#fff",
              padding: "10px",
              color: "#ccc",
              borderBottom: "1px solid #ccc",
              cursor: "pointer",
              fontStyle: "italic",
            }}
          >
            Data perguruan tinggi tidak ditemukan.
          </div>
        );
      }
    }

    let form = "";
    if (sessiondata.i_idrole === 10 || sessiondata.i_idrole === 1) {
      form =
        <input
          type="text"
          style={{ marginTop: "1.8%", paddingLeft: "40px" }}
          className={`form-control form-control-lg form-control-solid `}
          placeholder="Login sebagai PT (Ketik Nama PT)"
          onChange={(e) =>
            this.onChangeSP(
              e,
              ""
            )
          }
          autoComplete="off"
          name="nama_sp"
          value={this.state.nama_sp}
        />
    }
    return (
      <>
        {loadSP}
        {form}
        {listSPPenugasan}
        <Modal
          size="sm"
          show={this.state.loadingAuth}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body>
            <div className="text-center">
              <span className="spinner spinner-black"></span> <span className="ml-8"> Silahkan ditunggu ... </span>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
export default LoginASPT;
